// extracted by mini-css-extract-plugin
module.exports = {"container":"add-token-panel_container__3Y_vR"};